import { ScatterChart, Scatter, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
import ChartGlassPanel from '../../components/ChartGlassPanel';

const data = [
  { experience: 1, salary: 30000 },
  { experience: 3, salary: 40000 },
  { experience: 5, salary: 60000 },
  { experience: 7, salary: 75000 },
];

export default function SalaryExperienceScatter() {
  return (
    <ChartGlassPanel>
      <div className="w-full h-64">
      <ResponsiveContainer width="100%" height="100%">
        <ScatterChart margin={{ top: 16, right: 24, left: 0, bottom: 0 }}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="experience" name="Experience (years)" type="number" tick={{ fontSize: 14 }} domain={[0, 'dataMax+1']} />
          <YAxis dataKey="salary" name="Salary" type="number" tickFormatter={v => `$${v/1000}k`} tick={{ fontSize: 14 }} domain={[0, 'dataMax+10000']} />
          <Tooltip cursor={{ strokeDasharray: '3 3' }} formatter={(value, name) => name === 'salary' ? `$${value}` : value} />
          <Scatter name="Employee" data={data} fill="#0ea5e9" />
        </ScatterChart>
      </ResponsiveContainer>
    </div>
    </ChartGlassPanel>
  );
}
